// assets
import UserOutlined from '@ant-design/icons/UserOutlined';

// icons
const icons = { UserOutlined };

// ==============================|| MENU ITEMS - USERS ||============================== //

const users = {
  id: 'users',
  title: 'Users',
  type: 'item',
  url: '/users',
  icon: icons.UserOutlined,
  permission: {
    module: 'users',
    level: 10 // View permission required
  }
};

export default users;
